import script from "./AppFooterSocials.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppFooterSocials.vue?vue&type=script&setup=true&lang=ts"

import "./AppFooterSocials.vue?vue&type=style&index=0&id=2a8fdbf0&lang=scss"

const __exports__ = script;

export default __exports__